



































import { Component, Vue, Prop } from 'vue-property-decorator'
import Tips from '@/components/Tips.vue'

@Component({
    components: {
        Tips
    }
})
export default class ConfirmCreateBoccoChannelModal extends Vue {
    @Prop({required: true})
    value!: string

    editForm: string | null = null


    get validEditForm() {
        if (this.editForm?.length != 0) {
            return true
        } else {
            return false
        }
    }

    mounted() {
        this.editForm = this.value
    }

    updateForm() {
        this.$emit("input", this.editForm)
    }

}
